import React, { useState } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField
} from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon, TrendingUp as TrendingUpIcon } from '@mui/icons-material';

const IsNullSection = ({ onUpdate, fieldOptions, boostInput = false }) => {
  const [selectedField, setSelectedField] = useState('');
  const [nullType, setNullType] = useState('is_null');
  const [boost, setBoost] = useState(1);

  const nullTypeOptions = [
    { value: 'is_null', label: 'Is Null' },
    { value: 'not_null', label: 'Not Null' }
  ];

  const handleIsNullAction = (actionType) => {
    if (!selectedField || !nullType) return;

    const updateData = {
      action: actionType,
      filter: nullType,
      field: selectedField,
      value: ''
    };

    // Add boost value if boostInput is enabled
    if (boostInput) {
      updateData.boost = boost;
    }

    onUpdate(updateData);
    setSelectedField(''); // Reset after adding
    setNullType('is_null');
  };

  return (
    <Box>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Field</InputLabel>
        <Select
          value={selectedField}
          label="Field"
          onChange={(e) => setSelectedField(e.target.value)}
        >
          {fieldOptions.map((field) => (
            <MenuItem key={field.value} value={field.value}>
              {field.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Null Type</InputLabel>
        <Select
          value={nullType}
          label="Null Type"
          onChange={(e) => setNullType(e.target.value)}
        >
          {nullTypeOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {boostInput && (
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          label="Boost"
          type="number"
          value={boost}
          onChange={(e) => setBoost(parseFloat(e.target.value) || 1)}
          inputProps={{ min: 0, step: 0.1 }}
        />
      )}

      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleIsNullAction('include')}
          disabled={!selectedField}
        >
          <AddIcon />
        </Button>

        {boostInput && (
          <Button
            variant="contained"
            color="success"
            onClick={() => handleIsNullAction('boost')}
            disabled={!selectedField}
          >
            <TrendingUpIcon />
          </Button>
        )}

        <Button
          variant="contained"
          color="error"
          onClick={() => handleIsNullAction('exclude')}
          disabled={!selectedField}
        >
          <RemoveIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default IsNullSection;

